import { render, staticRenderFns } from "./NewThumbnail.vue?vue&type=template&id=8747e98e&lang=pug"
import script from "./NewThumbnail.vue?vue&type=script&lang=js"
export * from "./NewThumbnail.vue?vue&type=script&lang=js"
import style0 from "./NewThumbnail.vue?vue&type=style&index=0&id=8747e98e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports